import { cn, getHeatColor, CATEGORY_COLORS } from "../../lib/utils";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "../ui/tooltip";

export function HeatMap({ data, categories, items, className }) {
  // data is item_averages object: { item_id: { average, item_name, category_id } }
  
  return (
    <TooltipProvider>
      <div className={cn("overflow-x-auto", className)} data-testid="heat-map">
        <div className="min-w-[600px]">
          {categories.map((category) => {
            const categoryItems = items[category.id] || [];
            
            return (
              <div key={category.id} className="mb-4">
                <div
                  className="flex items-center gap-2 mb-2 px-2 py-1 rounded"
                  style={{ borderLeft: `4px solid ${CATEGORY_COLORS[category.id]}` }}
                >
                  <span className="text-sm font-medium">{category.name}</span>
                </div>
                
                <div className="grid grid-cols-5 gap-1">
                  {categoryItems.map((item) => {
                    const itemData = data[item.id];
                    const score = itemData?.average || 0;
                    
                    return (
                      <Tooltip key={item.id}>
                        <TooltipTrigger asChild>
                          <div
                            className={cn(
                              "h-12 rounded flex items-center justify-center text-xs font-medium cursor-pointer transition-transform hover:scale-105",
                              getHeatColor(score),
                              score >= 7 ? "text-white" : "text-foreground"
                            )}
                            data-testid={`heat-cell-${item.id}`}
                          >
                            {score > 0 ? score.toFixed(1) : "-"}
                          </div>
                        </TooltipTrigger>
                        <TooltipContent>
                          <p className="font-medium">{item.name}</p>
                          <p className="text-xs text-muted-foreground">
                            Average: {score > 0 ? score.toFixed(2) : "No data"}
                          </p>
                        </TooltipContent>
                      </Tooltip>
                    );
                  })}
                </div>
              </div>
            );
          })}
        </div>
        
        {/* Legend */}
        <div className="flex items-center justify-center gap-1 mt-6 text-xs">
          <span className="text-muted-foreground mr-2">Score:</span>
          {[1, 3, 5, 7, 9].map((score) => (
            <div
              key={score}
              className={cn(
                "w-8 h-6 rounded flex items-center justify-center",
                getHeatColor(score),
                score >= 7 ? "text-white" : "text-foreground"
              )}
            >
              {score}
            </div>
          ))}
        </div>
      </div>
    </TooltipProvider>
  );
}
